const flowSteps = [
  { icon: 'ri-truck-line', label: 'Alım Partisi', color: 'primary' },
  { icon: 'ri-stack-line', label: 'Canlı Stok', color: 'primary' },
  { icon: 'ri-knife-line', label: 'Satış / Kurban / Adaklık / Dış Kesim', color: 'accent' },
  { icon: 'ri-bank-card-line', label: 'Ödeme / Havale', color: 'primary' },
  { icon: 'ri-contacts-book-2-line', label: 'Cari / Rapor / Portal', color: 'secondary' },
];

export default function SolutionSection() {
  return (
    <section id="cozum" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">
            CiftlikWeb tüm operasyonu tek merkezde toplar.
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-3xl mx-auto">
            CiftlikWeb, canlı hayvan işletmelerinin yıl boyu kullanabileceği profesyonel bir yönetim sistemidir. Kurban Bayramı yoğunluğu için güçlüdür, ancak sadece bayram dönemi için değil; günlük canlı hayvan alım-satım, stok, cari, ödeme ve raporlama süreçleri için tasarlanmıştır.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-center justify-center gap-3 md:gap-4 flex-wrap">
          {flowSteps.map((step, i) => (
            <div key={i} className="flex items-center gap-3 md:gap-4">
              <div
                className={`flex flex-col items-center gap-3 px-6 py-5 rounded-xl border-2 transition-all duration-300 min-w-[160px] ${
                  step.color === 'accent'
                    ? 'bg-accent-50 border-accent-200 hover:border-accent-400'
                    : step.color === 'secondary'
                    ? 'bg-secondary-50 border-secondary-200 hover:border-secondary-400'
                    : 'bg-primary-50 border-primary-200 hover:border-primary-400'
                }`}
              >
                <div
                  className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg ${
                    step.color === 'accent'
                      ? 'bg-accent-500'
                      : step.color === 'secondary'
                      ? 'bg-secondary-500'
                      : 'bg-primary-500'
                  }`}
                >
                  <i className={`${step.icon} text-background-50 text-lg md:text-xl`}></i>
                </div>
                <span className="text-xs md:text-sm font-semibold text-foreground-800 text-center whitespace-nowrap">
                  {step.label}
                </span>
              </div>

              {i < flowSteps.length - 1 && (
                <div className="hidden lg:flex items-center text-foreground-300">
                  <i className="ri-arrow-right-line text-xl"></i>
                </div>
              )}
              {i < flowSteps.length - 1 && (
                <div className="flex lg:hidden items-center text-foreground-300">
                  <i className="ri-arrow-down-line text-xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}